import {Controller} from '@hotwired/stimulus'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

// Sign out / stop impersonating (GF-2954): DELETE the configured URL and
// reload on success — the same fetch the React SignoutButton and
// ImpersonationStopper performed.
export default class extends Controller {
  static values = {url: String}

  perform() {
    fetch(this.urlValue, {
      method: 'DELETE',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken(),
      },
      credentials: 'same-origin',
    }).then((response) => {
      if (response.status === 204)
        window.location.reload()
    })
  }
}
